import * as React from 'react';
import card from '../../images/karta-mm.png'
import Account from "./Account";
import {getCurrentUser} from "../../utilities/Utilities";
import Services from "../../utilities/Services";
import {AplikacjeMobilne} from "../sharedComponents/AplikacjeMobilne";
import {NotificationManager} from "react-notifications";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { Map, Marker} from "./Map";

interface Props {
}

interface State {
    user: any,
    oddzialy: any,
    loading: boolean,
    selectedOddzial: any
}

export class TwojSklep extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            user: [],
            oddzialy: [],
            loading: false,
            selectedOddzial: []
        }
    }

    componentDidMount() {
        this.pobierzKlient();


    }

    pobierzOddzialy = () => {
        Services.getOddzialy()
            .then((response) => {
                if (response.status === 200) {

                    console.log("get Oddzialy ok");

                    this.setState({oddzialy: response.data.sort(
                            (a: any, b: any) => {
                                return a.adres.localeCompare(
                                    b.adres,
                                );
                            },
                        ).map((oddzial: any) => {return oddzial}), loading: false});

                    this.ustawMape(this.state.user.numag);

                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Oddzialy error');
        })
    }

    pobierzKlient = () => {
        this.setState({loading: true});

        //alert(axios.defaults.headers.common.Authorization)

        Services.getKlient(getCurrentUser().email)
            .then((response) => {
                if (response.status === 200) {

                    console.log("get Klient ok");

                    this.setState({user: response.data});

                    this.pobierzOddzialy();

                }
            }).catch((error) => {
            this.setState({loading: false});
            console.log('get Klient error');
        })
    }

    onChangeSklep = (e: any) => {

        this.setState({loading: true});

        Services.ustawSklepKlienta(e.target.value)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {

                    //this.setState({onRegister: true, registerLoading: false})
                    console.log("Zmiana Sklepu ok");
                    NotificationManager.info("Pomyślnie zmieniono twój sklep", 'Zmieniono sklep', 5000);

                    this.pobierzKlient();

                }
            }).catch((error) => {
            NotificationManager.error(error.response.data.message, 'Błąd zmiany sklepu', 5000);
            console.log('Zmiana Sklepu error');
        })

    }

    ustawMape = (numag: any) => {
        let odz = this.state.oddzialy;
        let oddzial: any = odz.find((o: any) => o.numag === numag)

        if(oddzial){
            this.setState({selectedOddzial: oddzial});
        }

    }

    renderd = (status: Status) => {
        return <h1>{status}</h1>;
    };

    render() {
        let {oddzialy, user, loading, selectedOddzial} = this.state;

        return <section id={'card'}>
            <h3>Twój sklep stacjonarny</h3>

            {/*<div className={'col-sm-3'}>Twój sklep:</div>*/}
            {(loading) ?
                <h5>Ładowanie...</h5>
                :
                <div>
                    <div className={'col-sm-8'}>
                        <select className={'form-control'}
                                placeholder={'Wybierz...'}
                                onChange={this.onChangeSklep}
                            //@ts-ignore
                                value={((user.numag) !== 0) ? user.numag : null}
                        >
                            <option value="" disabled selected>Wybierz twój sklep...</option>
                            {
                                oddzialy.map((oddzial: any) => (
                                    <option value={oddzial.numag}>{oddzial.miasto}, {oddzial.adres}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className={'col-sm-8 mt-3'}>
                        <b>{selectedOddzial.miasto}</b>
                        <p>{selectedOddzial.adres}</p>

                        <div dangerouslySetInnerHTML={{__html: selectedOddzial.opis}} className={'opisHtml'}/>

                        <b>Telefon:</b>
                        <p>{selectedOddzial.telefon}</p>
                    </div>

                    {(selectedOddzial) &&
                    <Wrapper apiKey={"AIzaSyCYy-Tt9kSNRzmS7Ix5VUPo6jIMgzWqx9A"} render={this.renderd}>
                        <Map center={{lat: Number(selectedOddzial.gpsLat), lng: Number(selectedOddzial.gpsLng)}}
                             // onClick={() => console.log('d')} onIdle={() => console.log('h')}
                             zoom={15}>
                            <Marker position={{lat: Number(selectedOddzial.gpsLat), lng: Number(selectedOddzial.gpsLng)}}/>
                        </Map>
                    </Wrapper>
                    }

                </div>
            }
        </section>
    }

}

export default TwojSklep;

